import {
  ClipboardDocumentListIcon,
  ShieldCheckIcon,
  UsersIcon
} from '@heroicons/react/24/outline';
import IntegrationLandingPage from '@/components/integrations/IntegrationLandingPage';
import { getIntegrationsI18nProps } from '@/utils/i18n';
import { useTranslations } from 'next-intl';

export default function ManualIntegrationPage() {
  const t = useTranslations('integrations.manual');
  const stats = [
    { title: t('stats.technicalSetup.title'), value: t('stats.technicalSetup.value'), hint: t('stats.technicalSetup.hint'), icon: ClipboardDocumentListIcon },
    { title: t('stats.bestFor.title'), value: t('stats.bestFor.value'), hint: t('stats.bestFor.hint'), icon: UsersIcon },
    { title: t('stats.dataControl.title'), value: t('stats.dataControl.value'), hint: t('stats.dataControl.hint'), icon: ShieldCheckIcon }
  ];
  const features = t.raw('features');
  const steps = t.raw('steps');
  const faqs = t.raw('faqs');

  return (
    <IntegrationLandingPage
      seo={{
        title: t('seo.title'),
        description: t('seo.description'),
        keywords: t('seo.keywords'),
        url: '/manual-integration'
      }}
      badge={t('badge')}
      title={t('title')}
      subtitle={t('subtitle')}
      primaryCta={{ label: t('cta.primary'), href: '/signup' }}
      secondaryCta={{ label: t('cta.secondary'), href: '/pricing' }}
      heroPanel={{
        media: (
          <img
            src="/integration/manual-integration.webp"
            alt="Manual dashboard integration"
            className="h-auto w-full object-contain"
          />
        )
      }}
      stats={stats}
      featuresTitle={t('section.featuresTitle')}
      featuresSubtitle={t('section.featuresSubtitle')}
      features={features}
      stepsTitle={t('section.stepsTitle')}
      stepsSubtitle={t('section.stepsSubtitle')}
      steps={steps}
      experienceTitle={t('section.experienceTitle')}
      experienceDescription={t('section.experienceDescription')}
      experienceBullets={t.raw('section.experienceBullets')}
      faqTitle={t('section.faqTitle')}
      faqSubtitle={t('section.faqSubtitle')}
      faqs={faqs}
      bottomCtaTitle={t('section.bottomCtaTitle')}
      bottomCtaSubtitle={t('section.bottomCtaSubtitle')}
      bottomPrimaryCta={{ label: t('section.bottomPrimaryCta'), href: '/signup' }}
      bottomSecondaryCta={{ label: t('section.bottomSecondaryCta'), href: '/contact' }}
    />
  );
}

export const getStaticProps = getIntegrationsI18nProps;
